<template>
  <div>
    <!-- Contenedor Mensaje de Bienvenida -->
    <div ref="bienvenidaRef" class="bienvenida-container">
      <img src="@/assets/separador1.png" alt="Decoración SVG" class="separador-img" />

      <div ref="mensajeRef" class="mensaje-bienvenida">
        {{ mensaje }}
      </div>

      <!-- Ícono 
      <div ref="iconoRef" class="icono-container">
        <i class="fas fa-heart icono"></i>
      </div>
-->
      <!-- Nombres -->
      <div ref="textoRef" class="nuevo-texto">
        ¡Nuestra historia comienza aquí!
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from 'vue';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default {
  name: 'BienvenidaPage',
  setup() {
    const bienvenidaRef = ref(null);
    const mensajeRef = ref(null);
    const textoRef = ref(null);
    const iconoRef = ref(null);

    const mensaje = ref('');
    const text = `Nuestro amor se convierte en eternidad, nos elegimos hoy y siempre.\n  Un “si” para toda la vida, con la bendición de Dios y sus promesas. \n
`;

    const escribirTexto = (texto, index) => {
      if (index < texto.length) {
        mensaje.value += texto.charAt(index);
        setTimeout(() => escribirTexto(texto, index + 1), 50);
      }
    };

    onMounted(() => {
      const elementos = [
        { ref: bienvenidaRef, delay: 0 },
        { ref: mensajeRef, delay: 0.5 },
        { ref: iconoRef, delay: 1.0 },
        { ref: textoRef, delay: 1.3 }
      ];

      elementos.forEach(({ ref, delay }) => {
        gsap.fromTo(
          ref.value,
          { opacity: 0, x: 100 },
          {
            opacity: 1,
            x: 0,
            duration: 1.4,
            delay,
            ease: 'power3.out',
            scrollTrigger: {
              trigger: ref.value,
              start: 'top 85%',
              toggleActions: 'play none none none'
            }
          }
        );
      });

      ScrollTrigger.create({
        trigger: mensajeRef.value,
        start: 'top 85%',
        onEnter: () => escribirTexto(text, 0),
        once: true
      });
    });

    return { bienvenidaRef, mensajeRef, textoRef, iconoRef, mensaje };
  }
};
</script>

<style scoped>
.bienvenida-container {
  position: relative;
  width: 100%;
  padding-top: 0px;
  margin: 20px auto;
  text-align: center;
    background-image: url('@/assets/7.png'); /* 🔹 pon tu imagen aquí */
     background-size: cover;      /* 🔹 la imagen cubre todo */
  background-position: center; /* centrada */
  background-repeat: no-repeat; /* no se repite */

  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.mensaje-bienvenida {
  font-family: 'padres';
  font-size: 16px;
  color: #333;
  font-weight: 400;
  padding: 20px 30px;
  white-space: pre-line;
  transition: color 0.3s;
}

.mensaje-bienvenida:hover {
  color: #5a534c;
}

.nuevo-texto {
  font-family: 'Corinthia', cursive;
  font-size: 34px;
  color: #1c1c1b;
  margin-top: 10px;
  margin-bottom: 15px;
  transition: color 0.3s ease-in-out;
}

.nuevo-texto:hover {
  color: #555;
}

.icono-container {
  margin: 5px 0 15px;
}

.icono {
  font-size: 18px;
  color: #c8ad7f;
  animation: pulsar 1.5s infinite;
}

@keyframes pulsar {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}

.separador-img {
  width: 100%;
  max-width: 50%;
  height: auto;
  display: block;
  margin-top: 20px;
}
</style>
